type IconProps = React.ComponentProps<'svg'>

export function PlusIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g transform="translate(4.25, 4.25)">
        <path
          d="M7.75 0c0.41421 0 0.75 0.33579 0.75 0.75l0 6.25 6.25 0c0.41421 0 0.75 0.33579 0.75 0.75 0 0.41421-0.33579 0.75-0.75 0.75l-6.25 0 0 6.25c0 0.41421-0.33579 0.75-0.75 0.75-0.41421 0-0.75-0.33579-0.75-0.75l0-6.25-6.25 0c-0.41421 0-0.75-0.33579-0.75-0.75 0-0.41421 0.33579-0.75 0.75-0.75l6.25 0 0-6.25c0-0.41421 0.33579-0.75 0.75-0.75z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}
